export const lazyLoad = function () {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    let active = false;
    if (active === false) {
        active = true;
        setTimeout(function () {
            lazyImages.forEach(function (lazyImage) {
                if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("lazy");
                    lazyImage.classList.remove("blur");
                    lazyImage.classList.add("unblur");
                    lazyImages = lazyImages.filter(function (image) {
                        return image !== lazyImage;
                    });
                }
            });
            active = false;
        }, 200);
    }
};



